import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { KnowledgeFilesService } from './knowledgeFilesApi';
import { AxiosError } from 'axios';

const initialState: any = {
    filesAreLoading: false,
    fileIsLoading: false,
    requestStatus: 'default',
    message: '',
};

export const tryToUploadFiles = createAsyncThunk<any, FormData>(
    'knowledgeFilesAiService/tryToFetchFiles',
    async (formData: FormData) => {
        const result = await KnowledgeFilesService.tryToUploadFiles(formData);
        return result?.data;
    },
);

export const tryToFetchKnowledgeFilesAiService = createAsyncThunk<any, undefined>(
    'knowledgeFilesAiService/tryToFetchKnowledgeFilesAiService',
    async () => {
        const result = await KnowledgeFilesService.tryToFetchKnowledgeFilesAiService();
        return result?.data?.data;
    },
);

export const tryToUploadKnowledgeFilesAiService = createAsyncThunk<any, any>(
    'knowledgeFilesAiService/tryToUploadKnowledgeFilesAiService',
    async (data, { rejectWithValue }) => {
        try {
            const result =
                await KnowledgeFilesService.tryToUploadKnowledgeFilesAiService(data);
            return result.data;
        } catch (error) {
            const err: any = error as AxiosError;
            return rejectWithValue(err?.response?.data?.message);
        }
    },
);

export const tryToDeleteKnowledgeFileAiService = createAsyncThunk<any, any>(
    'knowledgeFilesAiService/tryToDeleteKnowledgeFileAiService',
    async (id, { rejectWithValue }) => {
        try {
            const result = await KnowledgeFilesService.tryToDeleteKnowledgeFileAiService(
                id,
            );
            return result.data;
        } catch (error) {
            const err: any = error as AxiosError;
            return rejectWithValue(err?.response?.data?.message);
        }
    },
);

export const knowledgeFilesAiServiceSlice = createSlice({
    name: 'knowledgeFilesAiService',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // tryToFetchKnowledgeFiles
            .addCase(tryToFetchKnowledgeFilesAiService.pending, (state) => {
                state.filesAreLoading = true;
            })
            .addCase(tryToFetchKnowledgeFilesAiService.rejected, (state) => {
                state.filesAreLoading = false;
            })
            .addCase(tryToFetchKnowledgeFilesAiService.fulfilled, (state, action) => {
                state.filesAreLoading = false;
                state.knowledgeFilesAiService = action.payload;
            })

            // tryToUploadKnowledgeFiles
            .addCase(tryToUploadKnowledgeFilesAiService.pending, (state) => {
                state.fileIsLoading = true;
            })
            .addCase(tryToUploadKnowledgeFilesAiService.rejected, (state) => {
                state.fileIsLoading = false;
            })
            .addCase(tryToUploadKnowledgeFilesAiService.fulfilled, (state, action) => {
                state.fileIsLoading = false;
                state.knowledgeFilesAiService = [
                    ...(state?.knowledgeFilesAiService || []),
                    action.payload,
                ];
            })

            // tryToDeleteKnowledgeFile
            .addCase(tryToDeleteKnowledgeFileAiService.pending, (state) => {
                state.fileIsLoading = true;
            })
            .addCase(tryToDeleteKnowledgeFileAiService.rejected, (state) => {
                state.fileIsLoading = false;
            })
            .addCase(tryToDeleteKnowledgeFileAiService.fulfilled, (state, action) => {
                state.fileIsLoading = false;
                if (state.knowledgeFilesAiService)
                    state.knowledgeFilesAiService =
                        { ...state }.knowledgeFilesAiService?.filter(
                            (file: any) => file._id !== action.meta.arg,
                        ) || [];
            });
    },
});

export default knowledgeFilesAiServiceSlice.reducer;
